import { isMobile, isPC } from "@modules/util/device"
import {
    onNextClickMobile,
    onNextClickPc,
    onPaginationButtonClick,
    onPreviousClickMobile,
    onPreviousClickPc,
} from "./buttons"
import {
    getPagination,
    loadNextAdvertsButton,
    loadNextAdvertsButtonBottom,
    loadPreviousAdvertsButton,
    loadPreviousAdvertsButtonBottom,
    paginationSelect,
    paginationSelectBottom,
    setNextPage,
    setPreviousPage,
    showPreviousPaginationButton,
    updatePaginationButtons,
    updatePaginationSelect,
} from "./pagination"
import { onPaginationSelectClick } from "./select"
import "@modules/global/pagination/pagination.css"
import "@modules/util/Scrolling.ts"

const pagination = getPagination()
setNextPage(pagination.currentPage + 1)
setPreviousPage(pagination.currentPage - 1)
updatePaginationButtons(pagination)
updatePaginationSelect(pagination)

const telephonesex = document.getElementById("telephonesex")

if (pagination.currentPage > 1) {
    showPreviousPaginationButton()
}
loadNextAdvertsButton()?.addEventListener("click", async () => {
    await onPaginationButtonClick(loadNextAdvertsButton(), isMobile() ? onNextClickMobile : onNextClickPc)
})
loadPreviousAdvertsButton()?.addEventListener("click", async () => {
    await onPaginationButtonClick(loadPreviousAdvertsButton(), isMobile() ? onPreviousClickMobile : onPreviousClickPc)
})

// pc only bottom buttons
loadNextAdvertsButtonBottom()?.addEventListener("click", async () => {
    await onPaginationButtonClick(loadNextAdvertsButtonBottom(), isMobile() ? onNextClickMobile : onNextClickPc)

    telephonesex?.scrollIntoView({ behavior: "smooth" })
})
loadPreviousAdvertsButtonBottom()?.addEventListener("click", async () => {
    await onPaginationButtonClick(
        loadPreviousAdvertsButtonBottom(),
        isMobile() ? onPreviousClickMobile : onPreviousClickPc,
    )
    telephonesex?.scrollIntoView({ behavior: "smooth" })
})

if (isPC()) {
    paginationSelect()?.addEventListener("click", async (event: MouseEvent) =>
        onPaginationSelectClick(event, paginationSelect()),
    )
    paginationSelectBottom()?.addEventListener("click", async (event: MouseEvent) => {
        await onPaginationSelectClick(event, paginationSelectBottom(), true)
    })
}
